module.exports = __webpack_public_path__ + "img/insights.67c23ff5.svg";